/* (ignored) */


//////////////////
// WEBPACK FOOTER
// buffer (ignored)
// module id = 16
// module chunks = 1